
export const courseModules = [
  {
    id: 1,
    title: 'Introdução à Inteligência Artificial na Educação',
    description: 'Entenda o que é IA, como ela funciona e por que é essencial para o professor moderno.',
    duration: '1h30',
    lessons: [
      'O que é Inteligência Artificial e como ela impacta a educação',
      'Panorama atual: como escolas ao redor do mundo estão usando IA',
      'Mitos e verdades sobre IA na sala de aula',
      'Ética e responsabilidade no uso de IA com alunos'
    ],
    icon: 'ri-lightbulb-line'
  },
  {
    id: 2,
    title: 'Dominando o ChatGPT para Professores',
    description: 'Aprenda a usar o ChatGPT como seu assistente pedagógico pessoal, do planejamento à avaliação.',
    duration: '3h00',
    lessons: [
      'Criando sua conta e configurando o ChatGPT',
      'A arte dos prompts: como fazer perguntas eficazes',
      'Planejamento de aulas com ChatGPT passo a passo',
      'Criando atividades, exercícios e avaliações com IA',
      'Gerando materiais didáticos personalizados',
      'Adaptando conteúdo para diferentes níveis de aprendizagem'
    ],
    icon: 'ri-openai-fill'
  },
  {
    id: 3,
    title: 'Google Gemini na Prática Docente',
    description: 'Explore o poder do Gemini para criar conteúdos multimídia e enriquecer suas aulas.',
    duration: '2h30',
    lessons: [
      'Conhecendo o Google Gemini e suas funcionalidades',
      'Diferenças entre ChatGPT e Gemini: quando usar cada um',
      'Criando apresentações e materiais visuais com Gemini',
      'Análise de imagens e documentos com IA',
      'Integrando Gemini com Google Workspace para educação'
    ],
    icon: 'ri-gemini-fill'
  },
  {
    id: 4,
    title: 'Prompts Prontos para o Dia a Dia Escolar',
    description: 'Biblioteca completa de prompts testados e aprovados para todas as situações do cotidiano escolar.',
    duration: '2h00',
    lessons: [
      'Prompts para planejamento semanal e mensal',
      'Prompts para criação de provas e atividades avaliativas',
      'Prompts para relatórios e pareceres descritivos',
      'Prompts para comunicação com pais e responsáveis',
      'Prompts para projetos interdisciplinares',
      'Prompts para inclusão e adaptação curricular'
    ],
    icon: 'ri-file-text-line'
  },
  {
    id: 5,
    title: 'Metodologias Ativas com Inteligência Artificial',
    description: 'Combine o melhor das metodologias ativas com o poder da IA para engajar seus alunos.',
    duration: '2h00',
    lessons: [
      'Sala de aula invertida potencializada com IA',
      'Gamificação e IA: criando experiências envolventes',
      'Aprendizagem baseada em projetos com suporte de IA',
      'Rotação por estações com ferramentas de IA',
      'Personalização do ensino usando inteligência artificial'
    ],
    icon: 'ri-rocket-line'
  },
  {
    id: 6,
    title: 'Criando Materiais Didáticos com IA',
    description: 'Produza materiais profissionais em minutos: apostilas, apresentações, jogos e muito mais.',
    duration: '2h30',
    lessons: [
      'Criando e-books e apostilas com IA',
      'Gerando imagens educativas com ferramentas de IA',
      'Produzindo slides profissionais em minutos',
      'Criando jogos e atividades interativas',
      'Desenvolvendo materiais para educação especial'
    ],
    icon: 'ri-palette-line'
  },
  {
    id: 7,
    title: 'Avaliação e Feedback Inteligente',
    description: 'Otimize seu tempo com avaliações mais eficientes e feedback personalizado para cada aluno.',
    duration: '1h30',
    lessons: [
      'Criando rubricas de avaliação com IA',
      'Feedback personalizado e automatizado',
      'Análise de desempenho e identificação de dificuldades',
      'Relatórios individuais gerados com IA'
    ],
    icon: 'ri-bar-chart-box-line'
  },
  {
    id: 8,
    title: 'Bônus: Agentes de IA Especializados',
    description: 'Acesso exclusivo a três agentes de IA criados especialmente para professores brasileiros.',
    duration: 'Acesso ilimitado',
    lessons: [
      'Apresentação do Agente IA para Educação Infantil',
      'Como usar o agente para planejar atividades lúdicas',
      'Apresentação do Agente IA para Ensino Fundamental',
      'Como usar o agente para criar sequências didáticas',
      'Dicas avançadas para tirar o máximo dos agentes'
    ],
    icon: 'ri-robot-2-line',
    isBonus: true
  }
];

export const courseIncludes = [
  { icon: 'ri-play-circle-line', text: 'Mais de 16 horas de conteúdo em vídeo' },
  { icon: 'ri-infinity-line', text: 'Acesso vitalício a todo o material' },
  { icon: 'ri-file-word-2-line', text: 'Materiais prontos em Word e PDF' },
  { icon: 'ri-book-2-line', text: '2 e-books práticos inclusos' },
  { icon: 'ri-robot-2-line', text: '3 agentes de IA exclusivos como bônus' },
  { icon: 'ri-whatsapp-line', text: 'Suporte direto via WhatsApp' },
  { icon: 'ri-award-line', text: 'Certificado de conclusão de 40h' },
  { icon: 'ri-shield-check-line', text: 'Garantia incondicional de 15 dias' }
];

export const courseForWho = [
  {
    icon: 'ri-user-smile-line',
    title: 'Professores da Educação Infantil',
    description: 'Que desejam criar atividades lúdicas e planejamentos criativos com apoio da IA.'
  },
  {
    icon: 'ri-graduation-cap-line',
    title: 'Professores do Ensino Fundamental',
    description: 'Que querem otimizar seu tempo e criar materiais didáticos de qualidade.'
  },
  {
    icon: 'ri-team-line',
    title: 'Coordenadores e Gestores',
    description: 'Que buscam implementar IA na escola de forma estratégica e responsável.'
  },
  {
    icon: 'ri-heart-line',
    title: 'Educadores Iniciantes em Tecnologia',
    description: 'Não precisa de experiência prévia com IA. O curso começa do zero.'
  }
];

export const courseResults = [
  { number: '500+', label: 'Professores formados' },
  { number: '98%', label: 'Taxa de satisfação' },
  { number: '40h', label: 'De conteúdo prático' },
  { number: '15', label: 'Dias de garantia' }
];
